import { ReactNode } from 'react';

import { ProducerShell } from './producer-shell';

interface BuyerShellProps {
  children: ReactNode;
}

// Dedicated shell for buyer-only users. It currently reuses the producer shell
// chrome (icon rail, secondary nav, mobile drawer) — which already renders the
// buyer-only two-item navigation — so this is a thin, named seam. Keeping it
// separate lets the buyer experience diverge from the producer shell in later
// phases (its own routes, header, and payment-aware chrome) without touching
// producer code.
export function BuyerShell({ children }: BuyerShellProps) {
  return <ProducerShell>{children}</ProducerShell>;
}
